import styled from "styled-components";
import { Button } from "..";

export const CreditCardReceiptContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: inherit;

  width: 100%;
`;

export const Receipt = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  margin: 1rem 0;

  border-radius: 10px;
  width: 100%;

  background-color: #ffffff;

  footer {
    display: flex;
    align-items: center;
    justify-content: space-between;

    width: 100%;
    padding: 0 1rem;

    h2 {
      font-size: 0.75rem;
      color: #585858;
    }

    h3 {
      font-size: 1.125rem;
      color: #1dbf00;
    }
  }
`;

export const ReceiptItem = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
  padding: 0 1rem 0.75rem 1rem;

  border-bottom: 1px solid #f4f4f4;

  header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    width: 100%;

    > * {
      font-size: 0.75rem;
      color: #585858;
    }

    button {
      background: transparent;
      border: none;
      color: #51b8e8;
      cursor: pointer;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  > img {
    width: 5rem;
  }

  > h3 {
    display: flex;
    align-items: center;
    gap: 0.5rem;

    font-size: 1rem;
    text-align: start;

    img {
      max-height: 2rem;
    }
  }
`;

export const ConfirmButton = styled(Button)`
  text-transform: uppercase;
  width: fit-content;
  margin: 0 auto;
`;

export const ProgramCard = styled.div`
  display: flex;
  gap: 1rem;

  margin: 0 auto;

  text-align: start;

  * {
    margin: 0;
    font-size: 1rem;
  }

  p {
    font-size: 0.75rem;
    max-width: 40ch;
  }
`;

export const InstallmentsSelect = styled.div`
  display: flex;
  flex-direction: column;

  label {
    font-size: 0.75rem;
    text-align: end;
    margin-bottom: 0.25rem;
  }

  select {
    border-radius: 5px;
    border: 1px solid #ccc;
    padding: 5px 10px;
  }
`;
